import React from 'react';
import { useState, useEffect } from "react";
import { SearchableDropdown } from "../helpers/SearchableDropdown";
import { queryPlanTypes } from '../../services/systemService';
import { getText } from '../../i18n';

const PropertiesTotalPremiumByPlanType = ({item, setItem}) => {
    const [planTypes, setPlanTypes] = useState([]);

    //TODO: fix. this isn't a good way to stop the state from setting before user interaction, but it will work
    const [userInteractionHasStarted, setUserInteractionHasStarted] = useState(false);

    const [applyDataView, setApplyDataView] = useState(false);

    const updatePlanTypes = (options) => {
        setSelectedPlanTypes(options);
    }
    
    useEffect(() => {

        if(item.premiumByPlanTypePart){
            setDisplayEmployeePremium(!!item.premiumByPlanTypePart.eeCost);
            setDisplayEmployerPremium(!!item.premiumByPlanTypePart.empCost);
            setDisplayTotalPremium(!!item.premiumByPlanTypePart.totalCost);
        }
        
        //index plan types by ID for retrieval below
        let planTypesByID = {};
        planTypes.forEach((planType) => {
            planTypesByID[planType.id] = planType;
        });

        if (item && item.premiumExplodedPart && planTypes.length > 0) {
            let newSelectedPlanTypes = item.premiumExplodedPart.map((part) => {
                let pt = planTypes;
                return {
                    name: planTypesByID[part.planTypeId].name,
                    id: part.planTypeId,
                    explode: part.explode
                };
            });
            setSelectedPlanTypes(newSelectedPlanTypes);
        }
    }, [planTypes]);

    const [areInputsDisabled, setAreInputsDisabled] = useState(false);

    useEffect(() => {
        if (item !== undefined) {
            if(item.hasOwnProperty("templateStatus")){
                if(item.templateStatus===-1){
                    //Template is locked, activate view-only mode
                    setAreInputsDisabled(true);
                }
            }
            if(item.hasOwnProperty("applyDataFilter")){
                setApplyDataView(item.applyDataFilter || false);
            }else{
                // TEMPORARY BECAUSE WE DON'T HAVE applyDataFilter coming from backend yet
                setApplyDataView(false);
            }
        }
        
        /*if (item.premiumByPlanTypePart === null) {
            item.premiumByPlanTypePart = {};
        }*/

        queryPlanTypes().then((types) => {
            setPlanTypes(types);
        });
        
        setUserInteractionHasStarted(true);
    }, []);

    // TODO: Replace with actual saved/selected plan types for container
    const [selectedPlanTypes, setSelectedPlanTypes] = useState([]);
    useEffect(() => {
        //TODO: fix this. it let these hooks not run before the state is initialized
        if (!userInteractionHasStarted) return;
        item.premiumExplodedPart= selectedPlanTypes.map((planType) => {
            return {
                planTypeId: planType.id,
                explode: !!planType.explode
            };
        });

        setItem(item);
    }, [selectedPlanTypes]);

    const [displayEmployeePremium, setDisplayEmployeePremium] = useState(false);
    useEffect(() => {
        //TODO: fix this. it let these hooks not run before the state is initialized
        if (!userInteractionHasStarted) return;
        if (item.premiumByPlanTypePart === null) {
            item.premiumByPlanTypePart = {};
        }
        item.premiumByPlanTypePart.eeCost = displayEmployeePremium;
        setItem(item);
    }, [displayEmployeePremium]);

    const [displayEmployerPremium, setDisplayEmployerPremium] = useState(false);
    useEffect(() => {
        //TODO: fix this. it let these hooks not run before the state is initialized
        if (!userInteractionHasStarted) return;
        if (item.premiumByPlanTypePart === null) {
            item.premiumByPlanTypePart = {};
        }
        item.premiumByPlanTypePart.empCost = displayEmployerPremium;
        setItem(item);
    }, [displayEmployerPremium]);

    const [displayTotalPremium, setDisplayTotalPremium] = useState(false);
    useEffect(() => {
        //TODO: fix this. it let these hooks not run before the state is initialized
        if (!userInteractionHasStarted) return;
        if (item.premiumByPlanTypePart === null) {
            item.premiumByPlanTypePart = {};
        }
        item.premiumByPlanTypePart.totalCost = displayTotalPremium;
        setItem(item);
    }, [displayTotalPremium]);

    useEffect(() => {
        item.applyDataFilter = applyDataView;
        setItem(item);
    }, [applyDataView]);

    // useEffect(() => {
    //     updateItemPropertiesFromState();
    // },[
    //     displayEmployeePremium,
    //     displayEmployerPremium,
    //     displayTotalPremium
    // ]);

    return (
        <>
            <div style={{ margin: "26px 0px 0px 0px", display: "flex", alignItems: "center", lineHeight: "28px" }}>
                <input
                    type="checkbox"
                    checked={applyDataView}
                    className="form-check-input custom-checkbox"
                    onChange={() => {
                        setApplyDataView(!applyDataView);
                    }}
                    disabled={areInputsDisabled}
                />
                <span style={{ color: "#2F2B43", fontWeight: "500", fontSize: "16px" }}>{getText('msg_9d8480cea43b')}</span>
            </div>

            <div style={{ fontSize: "16px", fontWeight: "500", color: "rgba(47, 43, 67, 1)", marginTop: "26px", marginBottom: "10px" }}>{getText('msg_428f949e480c')}<span style={{ color: "#EF4E45", marginLeft: "4px", fontWeight: "500" }}>*</span></div>
            <SearchableDropdown options={planTypes} optionIDField="id" updateOptions={updatePlanTypes} savedOptions={selectedPlanTypes} savedOptionIDField="id" disabled={areInputsDisabled}/>

            <div style={{ fontSize: "16px", fontWeight: "500", color: "rgba(47, 43, 67, 1)", marginTop: "26px", marginBottom: "10px" }}>{getText('msg_08df905be678')}<span style={{ color: "#EF4E45", marginLeft: "4px", fontWeight: "500" }}>*</span></div>
            <div style={{ display: "flex", alignItems: "center", lineHeight: "28px", marginRight: "26px" }}>
                <input
                    type="checkbox"
                    className="form-check-input custom-checkbox"
                    checked={displayEmployerPremium}
                    onChange={() => {
                        setDisplayEmployerPremium(!displayEmployerPremium);
                    }}
                    disabled={areInputsDisabled}
                />
                <span style={{ color: "#2F2B43", fontWeight: "500", fontSize: "16px" }}>{getText('msg_3c2c23c11fc8')}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", lineHeight: "28px", marginRight: "26px" }}>
                <input
                    type="checkbox"
                    className="form-check-input custom-checkbox"
                    checked={displayEmployeePremium}
                    onChange={() => {
                        setDisplayEmployeePremium(!displayEmployeePremium);
                    }}
                    disabled={areInputsDisabled}
                />
                <span style={{ color: "#2F2B43", fontWeight: "500", fontSize: "16px" }}>{getText('msg_1b38e3948641')}</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", lineHeight: "28px", marginRight: "26px" }}>
                <input
                    type="checkbox"
                    className="form-check-input custom-checkbox"
                    checked={displayTotalPremium}
                    onChange={() => {
                        setDisplayTotalPremium(!displayTotalPremium);
                    }}
                    disabled={areInputsDisabled}
                />
                <span style={{ color: "#2F2B43", fontWeight: "500", fontSize: "16px" }}>{getText('msg_e6e70b817ad7')}</span>
            </div>

            <div style={{ fontSize: "16px", fontWeight: "500", color: "rgba(47, 43, 67, 1)", marginTop: "26px", marginBottom: "10px" }}>{getText('msg_348a70c10d07')}</div>
            <span style={{ fontSize: "14px", color: "rgb(102, 112, 133)" }}>{selectedPlanTypes.length <= 0 ? "Please select one or more plan types first" : ""}</span>
            {selectedPlanTypes.map((planType, index) => (
                <div style={{ display: "flex", alignItems: "center", lineHeight: "28px", marginRight: "26px" }}>
                    <input
                        type="checkbox"
                        className="form-check-input custom-checkbox"
                        checked={planType.explode}
                        onChange={() => {
                            setSelectedPlanTypes(selectedPlanTypes.map((p) => {
                                if (p.id === planType.id) {
                                    p.explode = !p.explode;
                                }
                                return p;
                            }));
                        }}
                        disabled={areInputsDisabled}
                    />
                    <span style={{ color: "#2F2B43", fontWeight: "500", fontSize: "16px" }}>{planType.name}</span>
                </div>
            ))}
        </>
    );
};

export default PropertiesTotalPremiumByPlanType;
